import { Button, message, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

import { getTransfers } from "../../actions/cards/cards";
import useAxios from "../../config/useAxios";
import { hasAccess } from "../../utils";
import Table from "../Common/Table/Table";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import InfiniteTransfersSection from "./InfiniteTransfersSection";

const CheckerTransfers = () => {
  const disputes = useDispatch();

  const {
    onCall: onCallApprove,
    data: approveData,
    reset: approveReset,
    loading: approveLoading,
  } = useAxios({ api: "/api/staff/transfers/v1/approve", method: "post" });
  const {
    onCall: onCallReject,
    data: rejectData,
    reset: rejectReset,
    loading: rejectLoading,
  } = useAxios({ api: "api/staff/transfers/v1/reject", method: "post" });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const loginRole = sessionStorage.getItem("role");
  const [isReject, setIsReject] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [topupData, setTopupData] = useState(false);
  const [bulkTopupData, setBulkTopupData] = useState({});
  const [isDetailPage, setIsDetailPage] = useState(false);
  const [reasonValue, setReasonValue] = useState("");
  const [page, setPage] = React.useState(1);
  const [bulkTransfers, setBulkTransfers] = React.useState("bulk");
  const [searchValue, setSearchValue] = useState("");
  const [bulkDeselectedRecords, setBulkDeselectedRecords] = useState({});
  const getTransfersData = useSelector(
    (state) => state?.transfers?.getTransfersData?.data?.response,
  );
  const getTransfersDataCount = useSelector(
    (state) => state?.transfers?.getTransfersData?.data,
  );
  const transfersLoader = useSelector(
    (state) => state?.transfers?.getTransfersData?.loading,
  );

  const quickColumns = useMemo(() => {
    const quickCol = [
      {
        title: "Created By User",
        dataIndex: "topup_by_user",
        key: "topup_by_user",
      },
      {
        title: "Top-up Amount",
        dataIndex: "amount",
        key: "amount",
        render: (text) => <div>Rs. {text}</div>,
      },
      {
        title: "Transaction Date & Time",
        dataIndex: "created_at",
        key: "created_at",
        render: (text) => (
          <div>{moment(text).format("DD MMM'YY, HH:mm:ss")}</div>
        ),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text) => {
          const style =
            text === "In Progress"
              ? { backgroundColor: "#fef4de", color: "#f6a907" }
              : {};
          return (
            <div className={`status status_${text}`} style={style}>
              {text
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/^\w/, (c) => c.toUpperCase())}
            </div>
          );
        },
      },
    ];

    if (bulkTransfers !== "bulk") {
      quickCol?.unshift({
        title: "Wallet Name",
        dataIndex: "list_of_wallets_and_topup_amount",
        key: "list_of_wallets_and_topup_amount",
        render: (text) => <div>{text?.[0]?.walletKeyIdentifier}</div>,
      });
      quickCol?.unshift({
        title: "Mobile Number",
        dataIndex: "card",
        key: "card",
        render: (text) => <div>{text?.employee_details?.mobile}</div>,
      });
      quickCol?.unshift({
        title: "Email",
        dataIndex: "card",
        key: "card",
        render: (text) => <div>{text?.employee_details?.email}</div>,
      });
      quickCol?.unshift({
        title: "Employee Name",
        dataIndex: "card",
        key: "card",
        render: (text) => <div>{text?.employee_details?.name}</div>,
      });
      quickCol?.unshift({
        title: "Employee ID",
        dataIndex: "card",
        key: "card",
        render: (text) => <div>{text?.employee_details?.employee_id}</div>,
      });
    }

    return quickCol;
  }, [bulkTransfers]);

  const bulkColumns = [
    {
      title: "Transaction Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => <div>{moment(text).format("DD MMM'YY, HH:mm:ss")}</div>,
    },
    {
      title: "Email",
      dataIndex: "received_email",
      key: "received_email",
    },
    {
      title: "No...of Cards",
      dataIndex: "total_no_of_cards",
      key: "total_no_of_cards",
    },
    {
      title: "Loaded Amount",
      dataIndex: "loaded_amount",
      key: "loaded_amount",
      render: (text) => <div>Rs. {text}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        const style =
          text === "In Progress"
            ? { backgroundColor: "#fef4de", color: "#f6a907" }
            : {};
        return (
          <div className={`status status_${text}`} style={style}>
            {text
              .replace(/_/g, " ")
              .toLowerCase()
              .replace(/^\w/, (c) => c.toUpperCase())}
          </div>
        );
      },
    },
  ];

  const topupDetails = useMemo(() => {
    if (!topupData) return [];

    const {
      card,
      status,
      amount,
      list_of_wallets_and_topup_amount,
      created_at,
      topup_by_user,
      current_card_balance,
    } = topupData;

    const data = [
      {
        label: "Card Number",
        value: card?.card_number ? `**** ${card.card_number.slice(-4)}` : "-",
      },
      {
        label: "Card Holder Name",
        value: `${card?.data?.firstName ? card?.data?.firstName : ""} ${card?.data?.middleName ? card?.data?.middleName : ""
          } ${card?.data?.lastName ? card?.data?.lastName : ""}`,
      },
      {
        label: "Status",
        value: (
          <div
            className={`status status_${status
              ?.toLowerCase()
              .replace(/ /g, "_")}`}
            style={
              status === "In Progress"
                ? { backgroundColor: "#fef4de", color: "#f6a907" }
                : {}
            }
          >
            {status
              ? status
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/^\w/, (c) => c.toUpperCase())
              : "-"}
          </div>
        ),
      },
      {
        label: "Opening Card Balance",
        value: `Rs ${card?.data?.cardBalance ?? 0}`,
      },
      {
        label: "Current Card Balance",
        value: `Rs ${current_card_balance ?? 0}`,
      },
      {
        label: "Top-up Amount",
        value: `Rs ${amount ?? 0}`,
      },
      {
        label: "CRN",
        value: `${card?.card_reference_no ?? "-"}`,
      },
    ];

    if (bulkTransfers === "quick") {
      list_of_wallets_and_topup_amount?.forEach((wallet) => {
        data.push({
          label: "Wallet Name",
          value: wallet.walletKeyIdentifier || "-",
        });
      });
    } else {
      list_of_wallets_and_topup_amount?.forEach((wallet) => {
        data.push(
          { label: "Wallet Name", value: wallet.walletKeyIdentifier || "-" },
          { label: "Wallet Amount", value: `Rs ${wallet.amount ?? 0}` },
        );
      });
    }

    data.push(
      {
        label: "Transaction Date & Time",
        value: moment(created_at).format("DD MMM'YY, HH:mm:ss"),
      },
      {
        label: "Created by User",
        value: topup_by_user || "-",
      },
    );

    return data;
  }, [topupData]);

  useEffect(() => {
    if (bulkTransfers !== "bulk-internal") {
      disputes(getTransfers({ type: bulkTransfers, id: bulkTopupData?.id }));
    }
  }, [bulkTransfers]);

  useEffect(() => {
    if (rejectData?.status || approveData?.status) {
      message.success(
        <span className="messageText">
          {rejectData?.message ? rejectData?.message : approveData?.message}
        </span>,
      );
      approveReset();
      rejectReset();
      setIsReject(false);
      setIsDetailPage(false);
      setIsApprove(false);
      setSelectedRowKeys([]);
      if (bulkTransfers === "bulk-internal") {
        disputes(getTransfers({ type: bulkTransfers, id: bulkTopupData?.id }));
      } else {
        setBulkTopupData({});
        disputes(getTransfers({ type: bulkTransfers }));
      }
      setPage(1);
    } else if (rejectData?.errors || approveData?.errors) {
      message.error(
        <span className="messageText">
          {rejectData?.message ? rejectData?.message : approveData?.message}
        </span>,
      );
      approveReset();
      rejectReset();
    }
  }, [rejectData, approveData]);

  const handleRowClick = (event, record) => {
    setIsDetailPage(true);
    setTopupData(record);
  };
  const handleBulkRowClick = (event, record) => {
    setBulkTopupData(record);
    setBulkTransfers("bulk-internal");
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,

    getCheckboxProps: (record) => {
      if (["approved", "rejected"].includes(record.status))
        return {
          disabled: true,
        };
    },
  };

  const handleReject = () => {
    setReasonValue("");
    setIsReject(true);
  };
  const handleApprove = () => {
    setIsApprove(true);
  };

  return (
    <>
      {transfersLoader && <Loader />}
      {isApprove && (
        <Modal
          open={isApprove}
          title="Approve"
          footer={[]}
          onCancel={() => {
            setIsApprove(false);
          }}
        >
          Are you sure you want to approve?
          <div className="d-flex">
            <Button
              key="1"
              htmlType="submit"
              className="formButton mt1"
              onClick={() => {
                if (selectedRowKeys?.length > 0) {
                  onCallApprove({
                    data: {
                      approval_ids: [...selectedRowKeys],
                    },
                    params: {
                      bulk: true,
                    },
                  });
                } else {
                  onCallApprove({
                    data: {
                      approval_id: topupData?.id,
                    },
                  });
                }
              }}
            >
              {" "}
              {approveLoading ? (
                <ClipLoader loading={approveLoading} size={20} color="#FFF" />
              ) : (
                "Confirm"
              )}
            </Button>
            <Button
              key="2"
              className="cancelButton ml1 mt1"
              onClick={() => {
                setIsApprove(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal>
      )}

      {isReject && (
        <Modal
          title="Enter Reject Reason"
          open={isReject}
          footer={[]}
          onCancel={() => {
            setIsReject(false);
            setReasonValue("");
          }}
        >
          <div>
            <TextArea
              rows={5}
              placeholder="Enter Reason"
              onChange={(e) => {
                setReasonValue(e?.target?.value);
              }}
            ></TextArea>
          </div>

          {topupData?.status == "active" ||
            topupData?.status == "rejected" ||
            !sessionStorage
              .getItem("is_corporate_checker")
              ?.includes("true") ? null : (
            <div className="d-flex">
              <Button
                key="1"
                className="cancelButton ml1 mt1"
                onClick={() => {
                  setIsReject(false);
                  setReasonValue("");
                }}
              >
                Cancel
              </Button>
              <Button
                key="2"
                className="formButton mt1 ml1"
                onClick={() => {
                  if (selectedRowKeys?.length > 0) {
                    onCallReject({
                      data: {
                        approval_ids: [...selectedRowKeys],
                        reject_reason: reasonValue,
                      },
                      params: {
                        bulk: true,
                      },
                    });
                  } else {
                    onCallReject({
                      data: {
                        approval_id: topupData?.id,
                        reject_reason: reasonValue,
                      },
                    });
                  }
                }}
                disabled={!reasonValue?.trim()}
              >
                {rejectLoading ? (
                  <ClipLoader loading={rejectLoading} size={20} color="#FFF" />
                ) : (
                  "Confirm"
                )}
              </Button>
            </div>
          )}
        </Modal>
      )}

      {isDetailPage && (
        <Modal
          title="Top-Up Details"
          open={isDetailPage}
          footer={[]}
          onCancel={() => {
            setIsDetailPage(false);
          }}
          className="right-alinged-modal width-value"
        >
          <div className="item-details p1 mt2">
            {topupDetails?.map((listElement, listIndex) => (
              <div className="item-detail" key={listIndex}>
                <label>{listElement?.label}</label>
                <p title={listElement?.value}>
                  {listElement?.value ? listElement?.value : "-"}
                </p>
              </div>
            ))}
          </div>
          {topupData?.status == "approved" ||
            topupData?.status == "rejected" ||
            !sessionStorage.getItem("is_corporate_checker")?.includes("true") ||
            !hasAccess("cc_transfer_approvals", "write") ? null : (
            <div className="d-flex">
              <Button
                key="1"
                className="formButton ml1 mt1"
                onClick={() => {
                  setIsApprove(true);
                }}
              >
                Approve
              </Button>
              <Button
                key="2"
                className="cancelButton mt1 ml1"
                onClick={() => {
                  setIsReject(true);
                }}
              >
                Reject
              </Button>
            </div>
          )}
        </Modal>
      )}

      <div className="heading-div">
        <PageHeader title={`Transfers`} />
      </div>

      {bulkTransfers === "bulk" && !bulkTopupData?.id ? (
        <Table
          columns={bulkColumns}
          data={getTransfersData?.bulk_uploads}
          isTopFilter={true}
          filterMenu={false}
          filter={true}
          isActionAfterSearch={false}
          hideExportButton={true}
          btnsComponent={
            <div className="d-flex">
              <Button
                key="1"
                className={`${bulkTransfers === "bulk" || bulkTransfers === "bulk-internal"
                    ? "formButton"
                    : "cancelButton"
                  } mt1`}
                onClick={() => {
                  setBulkTransfers("bulk");
                  setBulkTopupData({});
                  setSelectedRowKeys([]);
                  setPage(1);
                }}
              >
                Bulk Load
              </Button>
              <Button
                key="2"
                className={`${bulkTransfers === "quick" ? "formButton" : "cancelButton"
                  } mt1 ml1`}
                onClick={() => {
                  setBulkTransfers("quick");
                  setBulkTopupData({});
                  setSelectedRowKeys([]);
                  setPage(1);
                }}
              >
                Quick Load
              </Button>
            </div>
          }
          pagination={{
            showTotal: (total, range) => {
              return `Showing ${range[0]} to ${range[1]} of ${total} entries`;
            },
            total: getTransfersDataCount?.total_records || 0,
            current: page,

            onChange: (pagee) => {
              disputes(getTransfers({ page: pagee, type: bulkTransfers }));
              setPage(pagee);
            },
          }}
          handleRowClick={handleBulkRowClick}
          isSearch={true}
          rowClassName={"transfers"}
          isMore={true}
          isHeaderButton={hasAccess("cc_transfer_approvals", "write")}
        />
      ) : bulkTransfers === "bulk-internal" ? (
        <InfiniteTransfersSection
          bulkId={bulkTopupData?.id}
          savedDeselected={bulkDeselectedRecords[bulkTopupData?.id] || []}
          onUpdateDeselected={(records) => {
            setBulkDeselectedRecords((prev) => ({
              ...prev,
              [bulkTopupData?.id]: records,
            }));
          }}
          onBack={() => {
            setBulkTransfers("bulk");
            setBulkTopupData({});
            setPage(1);
          }}
          hasAccessToWrite={hasAccess("cc_transfer_approvals", "write")}
        />
      ) : (
        <Table
          btnsComponent={
            <div className="d-flex">
              <Button
                key="1"
                className={`${bulkTransfers === "bulk" || bulkTransfers === "bulk-internal"
                    ? "formButton"
                    : "cancelButton"
                  } mt1`}
                onClick={() => {
                  setBulkTransfers("bulk");
                  setBulkTopupData({});
                  setSelectedRowKeys([]);
                  setPage(1);
                }}
              >
                Bulk Load
              </Button>
              <Button
                key="2"
                className={`${bulkTransfers === "quick" ? "formButton" : "cancelButton"
                  } mt1 ml1`}
                onClick={() => {
                  setBulkTransfers("quick");
                  setBulkTopupData({});
                  setSelectedRowKeys([]);
                  setPage(1);
                }}
              >
                Quick Load
              </Button>
            </div>
          }
          columns={quickColumns}
          data={
            bulkTransfers === "quick"
              ? getTransfersData?.approvals
              : getTransfersData?.data?.topups
                ? getTransfersData?.data?.topups
                : []
          }
          isTopFilter={true}
          filter={true}
          filterMenu={false}
          isActionAfterSearch={false}
          hideExportButton={true}
          isSearch={bulkTransfers !== "bulk" ? false : true}
          handleSearch={(val) => {
            setSearchValue(val);
            if (bulkTransfers === "bulk-internal") {
              disputes(
                getTransfers({
                  type: bulkTransfers,
                  id: bulkTopupData?.id,
                  search: val,
                }),
              );
            } else {
              setBulkTopupData({});
              disputes(getTransfers({ type: bulkTransfers, search: val }));
            }
          }}
          // hasExport={bulkTransfers !== "bulk"}
          // isSearch={true}
          hasExport={false}
          pagination={{
            showTotal: (total, range) => {
              return `Showing ${range[0]} to ${range[1]} of ${total} entries`;
            },
            total: getTransfersDataCount?.total_records || 0,
            current: page,

            onChange: (pagee) => {
              if (bulkTransfers === "bulk-internal") {
                disputes(
                  getTransfers({
                    page: pagee,
                    type: bulkTransfers,
                    id: bulkTopupData?.id,
                  }),
                );
              } else {
                disputes(
                  getTransfers({
                    page: pagee,
                    type: bulkTransfers,
                    search: searchValue,
                  }),
                );
              }
              setPage(pagee);
            },
          }}
          handleRowClick={handleRowClick}
          rowSelection={rowSelection}
          selectedRows={selectedRowKeys}
          rejectClick={handleReject}
          approveClick={handleApprove}
          approveLoading={approveLoading || rejectLoading}
          rowClassName={"transfers"}
          isMore={true}
          isHeaderButton={hasAccess("cc_transfer_approvals", "write")}
          placeholder={"Search by Employee Name"}
        />
      )}
    </>
  );
};

export default CheckerTransfers;
